<script>
  import Icon from "../lib/Icon/Icon.svelte";
  import { Icons } from "../lib/Icon/Icons";
  import { Size } from "../lib/enums";

  export let label;
  export let value;
  export let locale;

  $: formattedValue = Intl.NumberFormat(locale, { style: "decimal", maximumFractionDigits: 2 }).format(Math.abs(Number.parseFloat(value))) + "%";
  $: changeColorClasses = (value ?? 0) > 0 ? "text-[#0F9F4F]" : "text-[#EE5D5D]";
</script>

<div class="w-[130px] flex flex-col items-center gap-y-1 py-3">
  <div class="text-sm font-medium text-neutral-1200 whitespace-nowrap">
    {label}
  </div>
  <div class="flex items-center">
    <Icon iconType={Icons.Arrow} size={Size.Small} class={(value ?? 0) > 0 ? "rotate-180" : "rotate-0"} pathFill={(value ?? 0) > 0 ? "#0F9F4F" : "#EE5D5D"} />
    <div class="text-xs font-medium {changeColorClasses}">
      {formattedValue}
    </div>
  </div>
</div>
